import React, { useContext } from "react";
import { MDBSideNavItem, MDBIcon } from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../Context/ThemeContext.js";

const NavigationItem = ({ icon, label, link, isActive, click }) => {
  const { isDarkUi } = useContext(ThemeContext);
  const themeClass = isDarkUi ? "dark" : "";
  return (
    <MDBSideNavItem>
      <Link onClick={click} className={isActive ? `sidenav-link ${themeClass} active` : `sidenav-link ${themeClass}`}>
        <MDBIcon fas icon={icon} className="fa-fw me-3" />
        {label}
      </Link>
    </MDBSideNavItem>
  )
};  


export default NavigationItem;
